var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fb-form-properties-manager',{attrs:{"id":"html-v1-properties-qavivd","fields":_vm.fields,"formId":_vm.formId}})
}
var staticRenderFns = []

export { render, staticRenderFns }